import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";

import SectionHeader from "../../../../util/component/SectionHeader";
import DashboardTabsManager from "./_components/tabs-manager/DashboardTabsManager";

import { getTotalBookingsDashboard } from "../../api/services";

import { DASHBOARD_TABS, DEFAULT_TIME } from "./types";
import { ReactQueryKey } from "../../types";
import { useRecoilValue } from "recoil";
import { mobilityStoreActivitiesByRegionFilterState, pendingBookingsByLocationFilterState, pendingBookingsBySegmentAndCategoryFilterState, tabState } from "./recoil";

/**
 * Dashboard page
 * The header contain the KPI's.
 * In the content there are 3 tabs
 *  Pending bookings by Location
 *  Pending bookings By Segment and Category
 *  Mobility Stores Activity By Region
 */
const DashboardPage = () => {

    const {t} = useTranslation('booking');
    const tab = useRecoilValue(tabState);

    const pendingBookingsByLocationFilter = useRecoilValue(pendingBookingsByLocationFilterState);
    const pendingBookingsBySegmentAndCategoryFilter = useRecoilValue(pendingBookingsBySegmentAndCategoryFilterState);
    const mobilityStoreActivitiesByRegionFilter = useRecoilValue(mobilityStoreActivitiesByRegionFilterState);

    const { tenants, dealers } = ({
        [DASHBOARD_TABS.PENDING_BOOKINGS_BY_LOCATIONS]: pendingBookingsByLocationFilter,
        [DASHBOARD_TABS.PENDING_BOOKINGS_BY_SEGMENT_AND_CATEGORY]: pendingBookingsBySegmentAndCategoryFilter,
        [DASHBOARD_TABS.MOBILITY_STORE_ACTIVITIES_FOR_REGION]: mobilityStoreActivitiesByRegionFilter,
    })[tab];

    const totalDashboardQuery = useQuery({
        queryKey: [ReactQueryKey.TotalHeaderDashboard, { tenants: tenants || [], dealers: dealers || [] }],
        queryFn: () => getTotalBookingsDashboard({ tenants: tenants || [], dealers: dealers || [] })
    });

    return (
        <>
            <SectionHeader title={t('label.bookingDashboard')} subtitle={
                <Stack direction="row" alignItems="center" columnGap={3}>
                    <Stack direction="row" alignItems="center" columnGap={1}>
                        <Typography variant="bodySmall">{t('label.dashboardToBeWorkedLabel')}</Typography>
                        <Typography variant="h6">{totalDashboardQuery.data?.pending}</Typography>
                    </Stack>
                    <Stack direction="row" alignItems="center" columnGap={1}>
                        <Typography variant="bodySmall">{t('label.dashboardMaxIdleTimeLabel')}</Typography>
                        <Typography variant="h6">{!!totalDashboardQuery.data?.maxIdleTime ? totalDashboardQuery.data.maxIdleTime : DEFAULT_TIME}</Typography>
                    </Stack>
                    <Stack direction="row" alignItems="center" columnGap={1}>
                        <Typography variant="bodySmall">{t('label.dashboardWorkedTodayLabel')}</Typography>
                        <Typography variant="h6">{totalDashboardQuery.data?.worked}</Typography>
                    </Stack>
                    <Stack direction="row" alignItems="center" columnGap={1}>
                        <Typography variant="bodySmall">{t('label.dashboardAvgWorkingTimeLabel')}</Typography>
                        <Typography variant="h6">{!!totalDashboardQuery.data?.avgWorkingTime ? totalDashboardQuery.data.avgWorkingTime : DEFAULT_TIME}</Typography>
                    </Stack>
                    <Stack direction="row" alignItems="center" columnGap={1}>
                        <Typography variant="bodySmall">{t('label.dashboardMaxWorkingTimeLabel')}</Typography>
                        <Typography variant="h6">{!!totalDashboardQuery.data?.maxWorkingTime ? totalDashboardQuery.data.maxWorkingTime : DEFAULT_TIME}</Typography>
                    </Stack>
                </Stack>
            }/>
            <DashboardTabsManager />
        </>
    );
}

export default DashboardPage;
